import {
  type FormEvent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { authClient, readElectronAuthQuery } from './auth-client.js';

export function App() {
  const query = useMemo(
    () => readElectronAuthQuery(window.location.search),
    [],
  );
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const redirectPoll = useRef<ReturnType<
    typeof authClient.ensureElectronRedirect
  > | null>(null);

  const startRedirectPoll = useCallback(() => {
    if (redirectPoll.current) clearInterval(redirectPoll.current);
    redirectPoll.current = authClient.ensureElectronRedirect();
  }, []);

  useEffect(() => {
    if (!query) return;
    startRedirectPoll();
    return () => {
      if (redirectPoll.current) clearInterval(redirectPoll.current);
      redirectPoll.current = null;
    };
  }, [query, startRedirectPoll]);

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!query || pending) return;

    setPending(true);
    setError(null);
    try {
      const result = await authClient.signIn.email({
        email,
        password,
        fetchOptions: { query },
      });
      if (result.error) {
        setError('登录失败，请检查账号和密码后重试。');
      } else {
        startRedirectPoll();
      }
    } catch {
      setError('登录服务暂时不可用，请稍后重试。');
    } finally {
      setPending(false);
    }
  };

  return (
    <main className="page">
      <section className="panel">
        <p className="eyebrow">SecondClone</p>
        <h1>安全登录</h1>
        <p>认证完成后将自动返回 SecondClone 客户端。</p>

        {query ? (
          <form onSubmit={(event) => void submit(event)}>
            <label>
              邮箱
              <input
                type="email"
                name="email"
                value={email}
                onChange={(event) => setEmail(event.currentTarget.value)}
                autoComplete="username"
                required
                disabled={pending}
              />
            </label>
            <label>
              密码
              <input
                type="password"
                name="password"
                value={password}
                onChange={(event) => setPassword(event.currentTarget.value)}
                autoComplete="current-password"
                required
                disabled={pending}
              />
            </label>
            <button type="submit" disabled={pending}>
              {pending ? '正在登录…' : '登录'}
            </button>
          </form>
        ) : (
          <p className="error">登录请求无效，请从 SecondClone 客户端重新发起。</p>
        )}
        {error ? <p className="error">{error}</p> : null}
      </section>
    </main>
  );
}
